<style lang="stylus" scoped>
@import "../cardMap.stylus"
.map-card-cont .map-card-lib:nth-child(even){
  background:#F8F8F8;
}
.map-card
  border:1px solid #ccc
</style>
<template>
  <div class="map-card">
    <div class="map-card-cont" style='top:0;'>
      <div
        class="map-card-lib"
        style='margin-top:0;border:0;border-radius:0;'
        v-for="(it,index) in cardItem"
        :key="index"
        :class="it.selected?'map-card-active':''"
      >
        <div class="_lib1">{{it.name}}</div>
        <div class="_lib3">{{format(it.value)}}辆</div>
      </div>
    </div>
  </div>
</template>

<script>
import allData from '../index.js'
    export default {
        name: 'mapCard',
        data() {
            return {
                cardItem: allData.list,
                cardItemLeth:0,
                details:{},
            };
        },
        mounted(){
        },
        methods: {
            format (num) {
                var reg=/\d{1,3}(?=(\d{3})+$)/g;   
                return (num + '').replace(reg, '$&,');  
            }
        }
    };
</script>
